import { withStyles } from "@mui/styles";
import { useHistory } from "react-router-dom";
import { useQueryParams } from "~/shared/utils/sharedUtils.js";

import { Button, Card, CardBody, GridContainer, GridItem } from "~/shared/components/MuiComponents.jsx";

import { COLOR_KICK_BLUE } from "~/shared/sharedConstants.js";
import consultationStyles from "../styles/consultationStyles";

import imgExpertMedicalGuidance from "../../../../images/expert-medical-guidance.svg";
import imgSleepCoaching from "../../../../images/personalized-sleep-coaching-icon.svg";
import imgTrialPrescriptionIcon from "../../../../images/trial-prescription-icon.svg";

const liStyle = {
  display: "flex",
  alignItems: "center",
  marginBottom: "24px",
};

const iconStyle = {
  marginRight: "16px",
  height: "22px",
};

const v2Icon = {
  height: "150px",
  width: "150px",
};

const SleepMembershipDescriptionV2 = ({ classes, match }) => {
  const history = useHistory();
  const queryParams = useQueryParams();
  const checkoutSessionID = queryParams.get("checkoutSessionID");
  if (!checkoutSessionID) {
    window.location.href = "/me/portal";
  }

  return (
    <div
      className={`${classes.container} sleep-membership-description`}
      style={{ backgroundColor: COLOR_KICK_BLUE }}
    >
      <GridContainer justifyContent="center">
        <GridItem xs={10} sm={10} md={9}>
          <h3
            style={{
              color: "#FFFFFF",
              fontFamily: "Spectral-SemiBold",
              fontSize: "32px",
              marginTop: "40px",
            }}
          >
            12-Week Stanford MD Sleep Program
          </h3>
          <p
            style={{
              color: "#FFFFFF",
              fontFamily: "BasisGrotesquePro-Regular",
              fontSize: "18px",
              lineHeight: "26px",
              textAlign: "left",
              // letterSpacing: "-0.21px"
            }}
          >
            No long wait times for a specialist, Unlimited sleep medication
            dosing trials, HSA/FSA discounts, and more...
          </p>
        </GridItem>
        <GridItem xs={12} sm={12} md={9}>
          <Card className={classes.cardConsultation}>
            <CardBody
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "0 2px",
              }}
            >
              <div
                className="desc-container"
                style={
                  {
                    // color: kickBlue,
                  }
                }
              >
                <h3
                  style={{
                    textAlign: "center",
                    margin: "0",
                    // border: "1px solid yellow"
                  }}
                >
                  Your 12-week sleep plan includes:
                </h3>

                <div className="sleep-membership-item-container">
                  <div className="desc-item">
                    <img
                      style={{ ...v2Icon, position: "relative", top: "-30px" }}
                      className="img-trial-prescriptions"
                      src={imgTrialPrescriptionIcon}
                      alt="Trial Prescriptions"
                      loading="lazy"
                    />
                    <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                      The Best Sleep Medication For You
                    </p>

                    <p>
                      Over 12 weeks, try different doses of meds chosen by
                      Kick's sleep experts, such as: Hydroxyzine, Ramelteon,
                      Trazodone, Cyclobenzaprine, Quetiapine or Guanfacine
                    </p>
                  </div>
                  <div className="desc-item">
                    <img
                      style={{ ...v2Icon, position: "relative", left: "26px" }}
                      src={imgExpertMedicalGuidance}
                      alt="Expert Medical Guidance"
                      loading="lazy"
                    />
                    <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                      Doctors Notes For Deep Discounts
                    </p>

                    <p>
                      Save up to 37% on gym memberships, yoga classes,
                      supplements, pillows, and more by using our customized
                      doctor notes with an HSA or FSA account
                    </p>
                  </div>
                  <div className="desc-item">
                    <img
                      style={{
                        ...v2Icon,
                        position: "relative",
                        top: "9px",
                        left: "-14px",
                      }}
                      src={imgSleepCoaching}
                      alt="Personalized Sleep Coaching"
                      loading="lazy"
                    />
                    <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                      Healthy Habits Sleep Coaching
                    </p>

                    <p>
                      Your personal sleep coach provides the support and
                      accountability needed to build better sleep habits and
                      reduce bedtime procrastination
                    </p>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
          <Button
            onClick={() => {
              const { consultationType } = match.params;
              history.push(
                `/visits/${consultationType}/select-pharmacy?checkoutSessionID=${checkoutSessionID}`,
              );
            }}
            style={{
              display: "block",
              backgroundColor: "#F25930",
              margin: "30px auto",
              width: "300px",
              fontSize: "18px",
              fontWeight: "medium",
              textTransform: "unset",
            }}
          >
            Continue
          </Button>
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default withStyles(consultationStyles)(SleepMembershipDescriptionV2);
